module.exports = new __parcel__URL__("google_fr.a3cbecd8.jpeg").toString();